import { ModuleDeletiondMonitoring } from "./module-deletion-monitoring";

export class PartialDownload{
    courseCode : string;
    moduleId : number;
    isVideoDownload : boolean;
}